import closeIcon from "../../../assets/images/close_icon.svg";
import warningIcon from "../../../assets/images/warning_icon.png";
import "./Popup.css";
import "./WarningPopup.css";

const Popup = ({
  isVisible,
  onClose,
  children,
  popupStyle,
  title,
  handelPrimery,
  handelSecondry,
  FirstBtnTitle,
  SecondBtnTitle,
  primaryButtonDisabled,
  isWarning,
  style
}) => {
  if (!isVisible) return null;

  return (
    <>
      <div className="backdrop" onClick={onClose}></div>
      <div className={`popup ${isWarning ? 'warning-popup' : ''}`} style={popupStyle}>
        {isWarning && (
          <div className="warning-icon-container">
            <img src={warningIcon} alt="warning" className="warning-icon" />
          </div>
        )}
        <h4 className={`popupTitel ${isWarning ? 'warning-title' : ''}`}>{title}</h4>
        {isWarning && <h5 className="warning-subtitle">Are you sure?</h5>}
        <button className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close button" />
        </button>
        <div className="popup-content">{children}</div>
        <div className="popbtnCont">
          <button 
            className={isWarning ? 'warning-no-btn' : 'light_popbtn'} 
            onClick={handelSecondry}
          >
            {FirstBtnTitle}
          </button>
          <button 
            className={isWarning ? 'warning-yes-btn' : 'dark_btn'}
            onClick={handelPrimery}
            disabled={primaryButtonDisabled}
            style={primaryButtonDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            {SecondBtnTitle}
          </button>
        </div>
      </div>
    </>
  );
};

export default Popup;
